namespace GeniuzPOS.Purchase {
@Serenity.Decorators.registerClass()
export class PoPo05DtPendingPIforIrEditor extends Serenity.Extensions.GridEditorBase<PoPo05DtPendingPIforIrRow> {
    protected getColumnsKey() { return PoPo05DtPendingPIforIrColumns.columnsKey; }
    protected getDialogType() { return PoPo05DtPendingPIforIrDialog; }
    protected getLocalTextPrefix() { return PoPo05DtPendingPIforIrRow.localTextPrefix; }


    constructor(container: JQuery) {
        super(container);
    }
    protected getButtons() {
        var buttons = super.getButtons();

        // remove first button (Add button)
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
        buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)
      
        return buttons;
    }



    protected getSlickOptions() {
        var opt = super.getSlickOptions();
        opt.showFooterRow = true;
        // opt.frozenColumn = 1;
        return opt;
    }

    protected getViewOptions() {
        var opt = super.getViewOptions();
        opt.localSort = true;
        return opt;
    }

    protected usePager() {
        return false;
    }

    
}}